import axios from "axios";
import { getFirestore } from "firebase/firestore";

import { TYPES } from "./user.type";
import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";
import { getApiFunctions } from "../api";
import { stringToBlob } from "util/string2blob.function";

const app = getApp(PROJECT_ID);
const firestore = getFirestore(app);

// -------------------------- update display name --------------------------

//
export const cloudUpdateInfo =
  ({ displayName, base64 }, callback) =>
  async (dispatch) => {
    // check photo URL trước.
    if (base64 !== "" && !base64?.includes("storage.googleapis.com")) {
      const isUploadPhoto = await updatePhotoURL({ base64 });
      if (!isUploadPhoto) {
        callback &&
          callback({
            status: 500,
            data: "Upload đã xảy ra lỗi, xin vui lòng thử lại sau!",
          });
        return;
      }
    }

    if (displayName !== "") {
      const isUploadName = await updateDisplayName({ displayName });
      if (isUploadName) {
        callback && callback({ status: 200 });
      } else {
        callback &&
          callback({
            status: 500,
            data: "Cập nhật tên đã xảy ra lỗi, xin vui lòng thử lại sau!",
          });
      }
    }
  };

const updateDisplayName = async ({ displayName }) => {
  const functions = getApiFunctions().account.updateDisplayName;
  const options = { displayName };
  return functions(options)
    .then(() => {
      return true;
    })
    .catch((err) => {
      console.log({ err });
      return false;
    });
};

// update photoURL
const updatePhotoURL = async ({ base64 }) => {
  const file = stringToBlob(base64);
  const contentType = file?.type;

  console.log({ contentType });
  const responseUrl = await getSignedUrl({
    contentType,
  });
  const signedUrl = responseUrl?.data?.url;
  console.log({ responseUrl });
  if (!signedUrl) {
    return false;
  }

  try {
    const response = await axios
      .put(signedUrl, file.blob, {
        headers: {
          "Content-Type": file.type || "image/jpg",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          console.log({ percentCompleted });
        },
      })
      .catch((err) => {
        console.log({ err });
      });

    console.log({ response });
    return true;
  } catch (error) {
    console.error("Upload failed", error);
    return false;
  }
};

export const uploadPhotoTest = async ({ file }) => {
  const contentType = file?.type;
  console.log({ contentType });
  const responseUrl = await getSignedUrl({
    contentType,
  });
  const signedUrl = responseUrl?.data?.url;
  console.log({ responseUrl });
  if (!signedUrl) {
    return false;
  }

  try {
    const response = await axios
      .put(signedUrl, file, {
        headers: {
          "Content-Type": file.type || "image/jpg",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          console.log({ percentCompleted });
        },
      })
      .catch((err) => {
        console.log({ err });
      });

    console.log({ response });
    return true;
  } catch (error) {
    console.error("Upload failed", error);
    return false;
  }
};

// api upload image
const getSignedUrl = async ({ contentType }) => {
  const functions = getApiFunctions().account.updateAvatar;
  const options = { contentType };
  console.log({ options });
  return functions(options)
    .then((signedUrl) => {
      console.log({ signedUrl });
      return signedUrl;
    })
    .catch((err) => {
      console.log({ err });
      return null;
    });
};
// -------------------------- dispatch --------------------------

const getUsersSuccesss = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_USERS_SUCCESS,
    payload: data,
  });
};
